import Ajax from "Utils/ajax";
export const getStaffList = (data) => Ajax.post('hr/getStaffList',data);
export const leaveType = (data) => Ajax.post('hr/leaveType',data);
export const getLeaveRegisterHR = (data) => Ajax.post('hr/getLeaveRegisterHR',data);